import React, { useRef } from "react";
import { CContainer, CHeader, CHeaderNav, CNavItem } from "@coreui/react";
import AppHeaderDropdown from "../appHeaderDropdown";
import { useLocation } from "react-router-dom";

/**
 * @function AppHeader
 * @description for Navbar
 * @returns JSX for navbar
 */

const AppHeader = () => {
  const routes = [
    { path: "/", name: "Home" },
    { path: "/dashboard", name: "Dashboard" },
    { path: "/users", name: "Users" },
    { path: "/content-management", name: "Content Management" },
    { path: "/profile", name: "Profile" },
    { path: "/sites", name: "Sites" },
    { path: "/cities", name: "Cities" },
    { path: "/queries", name: "Queries" },
  ];

  const headerRef = useRef();
  const currentLocation = useLocation().pathname;
  const getRouteName = (pathname, routes) => {
    const currentRoute = routes.find((route) => route.path === pathname);
    return currentRoute ? currentRoute.name : false;
  };
  const headerTitle = getRouteName(currentLocation, routes);
  return (
    <CHeader position="sticky" className="mb-2 p-0" ref={headerRef}>
      <CContainer className="border-bottom px-4  d-flex " fluid>
        <CHeaderNav className="">
          <CNavItem className="font-bold-large">{headerTitle}</CNavItem>
        </CHeaderNav>
        <CHeaderNav>
          <AppHeaderDropdown />
        </CHeaderNav>
      </CContainer>
    </CHeader>
  );
};

export default React.memo(AppHeader);
